/* Ghost Label cart drawer — replaces Essential Cart Drawer */
(function () {
  'use strict';
  if (window.__glcLoaded) { if (window.GLCart && window.GLCart.rebind) window.GLCart.rebind(); return; }
  if (!window.GLCartConfig || !document.getElementById('glcDrawer')) return;
  window.__glcLoaded = true;

  var C, drawer, overlay, body, footer, timerEl, timerClock;
  var nativeFetch = window.fetch.bind(window);
  var root = ((window.GLCartConfig.routes && window.GLCartConfig.routes.root) || '/').replace(/\/$/, '');
  var cart = null;
  var busy = false;
  var giftSyncing = false;
  var productCache = {};
  var upsellIndex = 0;
  var discountOpen = false;
  var discountError = '';
  var lastFocus = null;

  /* ---------- helpers ---------- */
  function money(cents) {
    var fmt = C.moneyFormat || '${{amount}}';
    var value = (cents || 0) / 100;
    function withDelims(n, decimals, thousands, dec) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(dec);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        default: return withDelims(value, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function img(url, w) {
    if (!url) return '';
    url = url.replace(/^http:/, 'https:');
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function api(path, data) {
    var opts = { headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } };
    if (data) { opts.method = 'POST'; opts.body = JSON.stringify(data); }
    return nativeFetch(root + path, opts).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw j;
        return j;
      });
    });
  }
  function isGift(item) { return item.properties && item.properties._gl_gift; }

  var ICONS = {
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"><path d="M2 6h11v9H2zM13 9h4l3 3v3h-7z"/><circle cx="6" cy="17.5" r="1.8" fill="#fff"/><circle cx="16.5" cy="17.5" r="1.8" fill="#fff"/></svg>',
    gift: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M5 12v8h14v-8M12 8v12M12 8S10.5 4 8 4.5 7 8 12 8zm0 0s1.5-4 4-3.5S17 8 12 8z"/></svg>',
    percent: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M12 1.5l2.4 1.8 3-.2 1 2.8 2.6 1.6-.7 2.9L21.5 13l-1.8 2.4.2 3-2.8 1-1.6 2.6-2.9-.7L10 22.5l-2.4-1.8-3 .2-1-2.8-2.6-1.6.7-2.9L.5 11l1.8-2.4-.2-3 2.8-1 1.6-2.6 2.9.7z" transform="translate(1 0) scale(.92)"/><path d="M8.5 15.5l7-7" stroke="#fff" stroke-width="1.8" stroke-linecap="round"/><circle cx="9" cy="9" r="1.4" fill="#fff"/><circle cx="15" cy="15" r="1.4" fill="#fff"/></svg>',
    star: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"><path d="M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1-4.4-4.3 6.1-.9z"/></svg>',
    sample: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"><rect x="9" y="2.5" width="6" height="4" rx="1"/><rect x="6" y="6.5" width="12" height="15" rx="2"/><path d="M9 12h6"/></svg>'
  };
  var TAG = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M3 12.6V4a1 1 0 011-1h8.6a1 1 0 01.7.3l7.4 7.4a1 1 0 010 1.4l-8.6 8.6a1 1 0 01-1.4 0l-7.4-7.4a1 1 0 01-.3-.7zM8 9.5A1.5 1.5 0 108 6.5a1.5 1.5 0 000 3z"/></svg>';
  var TRASH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6"/></svg>';
  var CHEV = '<svg width="12" height="8" viewBox="0 0 12 8" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M1 1.5l5 5 5-5"/></svg>';

  /* ---------- spend calculation ---------- */
  function spendTotal() {
    if (!cart) return 0;
    var t = 0;
    cart.items.forEach(function (it) { if (!isGift(it)) t += it.final_line_price; });
    return t;
  }

  /* ---------- open / close ---------- */
  function open(skipRefresh) {
    if (!drawer.classList.contains('is-open')) lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    startTimer();
    if (skipRefresh === true) return;
    refresh().then(function () {
      var close = drawer.querySelector('[data-glc-close]');
      if (close) close.focus({ preventScroll: true });
    });
  }
  function close() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  window.GLCart = { open: function () { open(); }, close: close, refresh: function () { return refresh(); } };
  // Take over the theme's own cart functions
  window.openCart = function () { open(); };
  window.closeCart = close;
  window.toggleCart = function () { drawer.classList.contains('is-open') ? close() : open(); };

  /* ---------- instant add ---------- */
  // Open the drawer the moment an add request starts, with a placeholder row,
  // then drop the added line in from Shopify's reply before the full cart arrives.
  var SKELETON = '<div class="glc-item glc-item--skeleton" aria-hidden="true"><div class="glc-sk glc-sk--img"></div>' +
    '<div><div class="glc-sk glc-sk--line"></div><div class="glc-sk glc-sk--line glc-sk--short"></div></div><div class="glc-sk glc-sk--price"></div></div>';
  var addsPending = 0;
  function addStarted() {
    addsPending++;
    open(true);
    if (body.querySelector('.glc-item--skeleton')) return;
    var list = body.querySelector('.glc-items');
    if (list) { list.insertAdjacentHTML('afterbegin', SKELETON); list.scrollIntoView({ block: 'nearest' }); return; }
    var empty = body.querySelector('.glc-empty');
    if (empty) empty.outerHTML = '<div class="glc-items">' + SKELETON + '</div>';
    else body.insertAdjacentHTML('afterbegin', '<div class="glc-items">' + SKELETON + '</div>');
  }
  function addFinished(ok, data) {
    addsPending = Math.max(0, addsPending - 1);
    if (ok) lastChange = performance.now();
    var added = data && (data.items || (data.key ? [data] : null));
    if (ok && added && cart) {
      added.forEach(function (it) {
        var i = cart.items.findIndex(function (x) { return x.key === it.key; });
        if (i >= 0) cart.items[i] = it; else cart.items.unshift(it);
      });
      cart.item_count = cart.items.reduce(function (n, x) { return n + x.quantity; }, 0);
      cart.total_price = cart.items.reduce(function (n, x) { return n + x.final_line_price; }, 0);
      render();
    }
    if (!addsPending) {
      body.querySelectorAll('.glc-item--skeleton').forEach(function (el) { el.remove(); });
      footer.classList.add('glc-pending');
      refresh().then(function () { footer.classList.remove('glc-pending'); });
    }
  }

  /* ---------- timer ---------- */
  var timerInterval = null;
  function startTimer() {
    if (!C.showTimer || !timerEl) return;
    var key = 'glcTimerStart';
    var total = (C.timerMinutes || 10) * 60;
    var start;
    try { start = parseInt(sessionStorage.getItem(key), 10); } catch (e) {}
    var now = Math.floor(Date.now() / 1000);
    if (!start || now - start >= total) {
      start = now;
      try { sessionStorage.setItem(key, String(start)); } catch (e) {}
    }
    function tick() {
      var left = total - (Math.floor(Date.now() / 1000) - start);
      if (left <= 0) {
        start = Math.floor(Date.now() / 1000);
        try { sessionStorage.setItem(key, String(start)); } catch (e) {}
        left = total;
      }
      var m = Math.floor(left / 60), sec = left % 60;
      timerClock.textContent = (m < 10 ? '0' : '') + m + ':' + (sec < 10 ? '0' : '') + sec;
    }
    tick();
    clearInterval(timerInterval);
    timerInterval = setInterval(tick, 1000);
  }

  /* ---------- data ---------- */
  // `data` = a full cart object already in hand (e.g. the /cart/change.js response), so no re-fetch is needed.
  // Calls that arrive while a fetch is in flight share it, unless the cart changed after that fetch started.
  var inflight = null, inflightStart = 0, lastChange = 0;
  function applyCart(c) {
    cart = c;
    return syncGifts().then(function (changed) {
      if (changed) return api('/cart.js').then(function (c2) { cart = c2; });
    }).then(render);
  }
  function refresh(data) {
    if (data && typeof data.item_count === 'number') {
      return applyCart(data).catch(function (e) { console.error('[GL cart]', e); });
    }
    if (inflight && inflightStart >= lastChange) return inflight;
    inflightStart = performance.now();
    var p = inflight = api('/cart.js').then(applyCart)
      .catch(function (e) { console.error('[GL cart]', e); })
      .then(function () { if (inflight === p) inflight = null; });
    return p;
  }

  // Add or remove free gift products based on spend
  function syncGifts() {
    if (giftSyncing || !cart) return Promise.resolve(false);
    var spend = spendTotal();
    var tasks = [];
    (C.tiers || []).forEach(function (t) {
      if (!t.giftVariant) return;
      var line = cart.items.find(function (it) { return it.properties && it.properties._gl_gift === t.id; });
      if (spend >= t.amount && !line) {
        tasks.push(function () {
          return api('/cart/add.js', { items: [{ id: t.giftVariant, quantity: 1, properties: { _gl_gift: t.id } }] });
        });
      } else if (spend < t.amount && line) {
        tasks.push(function () { return api('/cart/change.js', { id: line.key, quantity: 0 }); });
      } else if (line && line.quantity > 1) {
        tasks.push(function () { return api('/cart/change.js', { id: line.key, quantity: 1 }); });
      }
    });
    if (!tasks.length) return Promise.resolve(false);
    giftSyncing = true;
    return tasks.reduce(function (p, fn) { return p.then(fn); }, Promise.resolve())
      .catch(function (e) { console.warn('[GL cart] gift sync', e); })
      .then(function () { giftSyncing = false; return true; });
  }

  // Remove / quantity: update the screen at once, then confirm with Shopify in the background.
  // Changes run one after another; only the last one re-renders, so rows never flicker back.
  var opQueue = Promise.resolve(), pendingOps = 0;
  // Shopify gives a line a new key when its discounts change (e.g. the 3-piece bundle kicks in),
  // so a line is also matched by variant + properties.
  function lineSig(it) { return it.variant_id + '|' + JSON.stringify(it.properties || {}); }
  function findLine(key, sig) {
    if (!cart) return null;
    return cart.items.find(function (it) { return it.key === key; }) ||
      (sig ? cart.items.find(function (it) { return lineSig(it) === sig; }) : null);
  }
  function quickChange(key, qty, row) {
    var sig = row && row.getAttribute('data-sig');
    var line = findLine(key, sig);
    if (!line) return;
    sig = sig || lineSig(line);
    var oldQty = row ? (parseInt(row.querySelector('.glc-qty span').textContent, 10) || line.quantity) : line.quantity;
    var shownCount = parseInt((document.querySelector('[data-glc-count]') || {}).textContent, 10);
    if (isNaN(shownCount)) shownCount = cart.item_count;
    paintCount(Math.max(0, shownCount + qty - oldQty));
    if (row) {
      if (qty === 0) {
        row.classList.add('glc-item--removing');
      } else {
        row.querySelector('.glc-qty span').textContent = qty;
        var minus = row.querySelector('[data-step="-1"]');
        if (minus) minus.disabled = qty <= 1;
        row.classList.add('glc-item--updating');
      }
    }
    footer.classList.add('glc-pending');
    pendingOps++;
    opQueue = opQueue
      .then(function () {
        var cur = findLine(key, sig);
        if (!cur) return cart;
        return api('/cart/change.js', { id: cur.key, quantity: qty });
      })
      .then(function (c) {
        lastChange = performance.now();
        if (pendingOps === 1) return refresh(c);
        cart = c;
      }, function (e) {
        lastChange = performance.now();
        alert((e && (e.description || e.message)) || 'Something went wrong. Please try again.');
        if (pendingOps === 1) return refresh();
      })
      .then(function () {
        pendingOps--;
        if (!pendingOps) footer.classList.remove('glc-pending');
      });
  }

  function withBusy(promise) {
    busy = true;
    drawer.classList.add('glc-loading');
    return promise
      .catch(function (e) {
        var msg = (e && (e.description || e.message)) || 'Something went wrong. Please try again.';
        alert(msg);
      })
      .then(function (res) { lastChange = performance.now(); return refresh(res); })
      .then(function () { busy = false; drawer.classList.remove('glc-loading'); });
  }

  function getProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = nativeFetch(root + '/products/' + handle + '.js').then(function (r) { return r.json(); });
    return productCache[handle];
  }

  /* ---------- render ---------- */
  function paintCount(n) {
    document.querySelectorAll('[data-glc-count], .cart-count, [data-cart-count], #cartCount, #cartDrawerCount, .cart-count-bubble span').forEach(function (el) {
      if (el.closest('.glc-drawer') && !el.hasAttribute('data-glc-count')) return;
      el.textContent = n;
    });
    document.querySelectorAll('.cart-toggle-btn').forEach(function (el) {
      el.classList.toggle('has-items', n > 0);
    });
  }

  function render() {
    if (!cart) return;
    paintCount(cart.item_count);
    if (timerEl) timerEl.hidden = !(C.showTimer && cart.item_count > 0);

    var html = '';
    if (C.showTiers && (cart.item_count > 0 || C.showTiersEmpty)) html += tiersHtml();
    if (cart.item_count === 0) {
      html += '<div class="glc-empty">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 5h2l2.2 10.2a1 1 0 001 .8h9.6a1 1 0 001-.8L20.5 8H6.2M9 20h.01M17 20h.01"/></svg>' +
        '<p>' + esc(C.emptyText) + '</p>' +
        '<a href="' + esc(C.emptyLink) + '" data-glc-close-link>' + esc(C.emptyButton) + '</a></div>';
    } else {
      html += '<div class="glc-items">' + cart.items.map(itemHtml).join('') + '</div>';
    }
    if (C.showUpsell) html += '<div data-glc-upsell></div>';
    body.innerHTML = html;
    positionTierLabels();
    hydrateVariantSelects();
    if (C.showUpsell) renderUpsell();
    renderFooter();
  }

  function tiersHtml() {
    var tiers = (C.tiers || []).filter(function (t) { return t.amount > 0; }).sort(function (a, b) { return a.amount - b.amount; });
    if (!tiers.length) return '';
    var n = tiers.length;
    var max = tiers[n - 1].amount;
    var spend = spendTotal();
    var next = tiers.find(function (t) { return spend < t.amount; });
    var msg = next
      ? C.spendTemplate.replace('[amount]', money(next.amount - spend)).replace('[reward]', esc(next.reward))
      : C.allUnlockedText;

    // Where each icon sits on the bar (0-100)
    var pos = tiers.map(function (t, i) {
      return C.tierSpacing === 'amount' ? (t.amount / max * 100) : ((i + 0.5) / n * 100);
    });

    // Fill follows the icons: reaching a tier's amount fills exactly to its icon
    var pct;
    if (C.tierSpacing === 'amount') {
      pct = Math.min(100, spend / max * 100);
    } else if (spend >= max) {
      pct = 100;
    } else {
      var prevAmt = 0, prevPos = 0;
      for (var i = 0; i < n; i++) {
        if (spend < tiers[i].amount) {
          var span = tiers[i].amount - prevAmt;
          pct = prevPos + (span > 0 ? (spend - prevAmt) / span : 1) * (pos[i] - prevPos);
          break;
        }
        prevAmt = tiers[i].amount; prevPos = pos[i];
      }
    }

    var icons = tiers.map(function (t, i) {
      return '<div class="glc-tier' + (spend >= t.amount ? ' is-reached' : '') + '" style="left:' + pos[i] + '%" title="' + esc(t.title) + '">' + (ICONS[t.icon] || ICONS.gift) + '</div>';
    }).join('');
    var labels = tiers.map(function (t, i) {
      return '<div class="glc-tier-label' + (spend >= t.amount ? ' is-reached' : '') + '" data-pct="' + pos[i] + '"><span class="glc-tier-label__title">' + esc(t.title) + '</span>' +
        (t.showAmount ? '<span class="glc-tier-label__amount">' + money(t.amount).replace(/\.00$/, '') + '</span>' : '') + '</div>';
    }).join('');
    return '<div class="glc-tiers"><p class="glc-tiers__msg">' + msg + '</p>' +
      '<div class="glc-track-wrap"><div class="glc-track"><div class="glc-track__fill" style="width:' + pct + '%"></div>' + icons + '</div></div>' +
      '<div class="glc-tier-labels">' + labels + '</div></div>';
  }

  // Keep labels centred under icons but inside the drawer
  function positionTierLabels() {
    var row = body.querySelector('.glc-tier-labels');
    if (!row) return;
    var w = row.offsetWidth;
    row.querySelectorAll('.glc-tier-label').forEach(function (l) {
      var x = w * parseFloat(l.getAttribute('data-pct')) / 100;
      var half = l.offsetWidth / 2;
      var margin = 14; // may hang slightly into the drawer padding
      x = Math.max(half - margin, Math.min(w - half + margin, x));
      l.style.left = x + 'px';
    });
  }

  function itemHtml(it) {
    var gift = isGift(it);
    var discounts = (it.line_level_discount_allocations || []).filter(function (d) { return d.amount > 0; });
    var discountHtml = discounts.map(function (d) {
      return '<div class="glc-item__discount">' + TAG + '<span>' + esc(d.discount_application.title) + '</span></div>';
    }).join('');
    var variant = (!it.product_has_only_default_variant && it.variant_title)
      ? '<div class="glc-item__variant" data-glc-variant data-handle="' + esc(it.handle) + '" data-key="' + esc(it.key) + '" data-variant="' + it.variant_id + '">' + esc(it.variant_title) + '</div>'
      : '';
    var price;
    if (gift && it.final_line_price === 0) {
      price = '<span class="glc-price__compare">' + money(it.original_line_price) + '</span><span class="glc-price__free">' + esc(C.freeText) + '</span>';
    } else {
      var compare = Math.max(it.original_line_price, (it.variant_compare_at_price || 0) * it.quantity);
      price = (compare > it.final_line_price ? '<span class="glc-price__compare">' + money(compare) + '</span>' : '') +
        '<span class="glc-price__final">' + money(it.final_line_price) + '</span>';
    }
    var controls = gift ? '' :
      '<div class="glc-controls">' +
        '<button type="button" class="glc-trash" data-glc-remove="' + esc(it.key) + '" aria-label="Remove ' + esc(it.product_title) + '">' + TRASH + '</button>' +
        '<div class="glc-qty">' +
          '<button type="button" data-glc-qty="' + esc(it.key) + '" data-step="-1" aria-label="Decrease quantity"' + (it.quantity <= 1 ? ' disabled' : '') + '>−</button>' +
          '<span aria-live="polite">' + it.quantity + '</span>' +
          '<button type="button" data-glc-qty="' + esc(it.key) + '" data-step="1" aria-label="Increase quantity">+</button>' +
        '</div></div>';
    return '<div class="glc-item" data-sig="' + esc(lineSig(it)) + '">' +
      '<a class="glc-item__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 200)) + '" alt="' + esc(it.product_title) + '" loading="lazy">' : '') + '</a>' +
      '<div>' +
        (gift ? '<span class="glc-gift-pill">' + esc(C.giftPill) + '</span>' : '') +
        '<a class="glc-item__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        discountHtml + variant +
      '</div>' +
      '<div class="glc-item__right"><div class="glc-price">' + price + '</div>' + controls + '</div>' +
    '</div>';
  }

  // Turn the size text into a dropdown once product variants are loaded
  function hydrateVariantSelects() {
    body.querySelectorAll('[data-glc-variant]').forEach(function (el) {
      var item = el.closest('.glc-item');
      if (item && item.querySelector('.glc-gift-pill')) return; // gifts keep fixed size
      getProduct(el.getAttribute('data-handle')).then(function (p) {
        if (!p || !p.variants || p.variants.length < 2 || !el.isConnected) return;
        var current = parseInt(el.getAttribute('data-variant'), 10);
        var opts = p.variants.map(function (v) {
          return '<option value="' + v.id + '"' + (v.id === current ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' + esc(v.title) + '</option>';
        }).join('');
        el.innerHTML = '<select class="glc-item__select" data-glc-switch="' + esc(el.getAttribute('data-key')) + '" aria-label="Size">' + opts + '</select>';
      }).catch(function () {});
    });
  }

  /* ---------- upsell ---------- */
  var upsellProducts = [];
  var recCache = {};
  function recommendations(productId) {
    if (!recCache[productId]) {
      recCache[productId] = nativeFetch(root + '/recommendations/products.json?product_id=' + productId + '&limit=10&intent=related')
        .then(function (r) { return r.json(); })
        .then(function (j) { return (j.products || []).map(normalizeRec); })
        .catch(function () { delete recCache[productId]; return []; });
    }
    return recCache[productId];
  }
  function renderUpsell() {
    var wrap = body.querySelector('[data-glc-upsell]');
    if (!wrap) return;
    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.product_id] = true; });
    var empty = cart.item_count === 0;
    var first = cart.items.find(function (it) { return !isGift(it); });

    var source = first ? recommendations(first.product_id) : Promise.resolve([]);

    source.then(function (list) {
      list = list.concat(C.fallbackProducts || []);
      var seen = {};
      upsellProducts = list.filter(function (p) {
        if (!p || !p.available || inCart[p.id] || seen[p.id]) return false;
        seen[p.id] = true; return true;
      }).slice(0, C.upsellLimit || 4);
      if (!upsellProducts.length) { wrap.innerHTML = ''; return; }
      if (upsellIndex >= upsellProducts.length) upsellIndex = 0;
      var cards = upsellProducts.map(upsellCard).join('');
      if (empty) {
        wrap.innerHTML = '<div class="glc-upsell"><div class="glc-upsell__head"><h3 class="glc-upsell__title">' + esc(C.emptyUpsellTitle) + '</h3></div><div class="glc-upsell__list">' + cards + '</div></div>';
      } else {
        wrap.innerHTML = '<div class="glc-upsell"><div class="glc-upsell__head"><h3 class="glc-upsell__title">' + esc(C.upsellTitle) + '</h3>' +
          (upsellProducts.length > 1 ? '<div class="glc-upsell__nav"><button type="button" data-glc-up="-1" aria-label="Previous product">' + chevron(true) + '</button><button type="button" data-glc-up="1" aria-label="Next product">' + chevron(false) + '</button></div>' : '') +
          '</div><div class="glc-upsell__viewport"><div class="glc-upsell__track" style="transform:translateX(-' + (upsellIndex * 100) + '%)">' + cards + '</div></div></div>';
      }
    });
  }
  function chevron(left) {
    return '<svg width="9" height="14" viewBox="0 0 9 14" fill="none" stroke="currentColor" stroke-width="1.8"><path d="' + (left ? 'M7.5 1.5L2 7l5.5 5.5' : 'M1.5 1.5L7 7l-5.5 5.5') + '"/></svg>';
  }
  function normalizeRec(p) {
    return {
      id: p.id, handle: p.handle, title: p.title, url: p.url, available: p.available,
      image: p.featured_image ? img(p.featured_image, 200) : '',
      variants: (p.variants || []).map(function (v) { return { id: v.id, title: v.title, price: v.price, available: v.available }; })
    };
  }
  function upsellCard(p) {
    var variants = p.variants.filter(function (v) { return v.available; });
    var v = variants[0] || p.variants[0];
    var variantUi = '';
    if (variants.length > 1) {
      variantUi = '<select class="glc-item__select glc-upsell__variant" data-glc-upvar aria-label="Size">' +
        variants.map(function (x) { return '<option value="' + x.id + '" data-price="' + x.price + '">' + esc(x.title) + '</option>'; }).join('') + '</select>';
    } else if (v && v.title !== 'Default Title') {
      variantUi = '<div class="glc-upsell__variant">' + esc(v.title) + '</div>';
    }
    return '<div class="glc-upsell__card">' +
      (p.image ? '<img class="glc-upsell__img" src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '<span></span>') +
      '<div><p class="glc-upsell__name">' + esc(p.title) + '</p>' + variantUi + '<div class="glc-upsell__price" data-glc-upprice>' + money(v ? v.price : 0) + '</div></div>' +
      '<button type="button" class="glc-add" data-glc-add="' + (v ? v.id : '') + '">+ Add</button></div>';
  }

  /* ---------- footer ---------- */
  function renderFooter() {
    if (cart.item_count === 0) { footer.hidden = true; footer.innerHTML = ''; return; }
    footer.hidden = false;
    var codes = (cart.discount_codes || []);
    var savings = cart.total_discount || 0;
    cart.items.forEach(function (it) {
      if (it.variant_compare_at_price && it.variant_compare_at_price > it.original_price) {
        savings += (it.variant_compare_at_price - it.original_price) * it.quantity;
      }
    });
    var html = '';
    if (C.showDiscount) {
      html += '<button type="button" class="glc-discount-toggle" data-glc-dtoggle aria-expanded="' + discountOpen + '">' + esc(C.discountLabel) + ' ' + CHEV + '</button>' +
        '<form class="glc-discount-form' + (discountOpen ? ' is-open' : '') + '" data-glc-dform>' +
          '<input type="text" name="code" placeholder="Discount code" autocomplete="off" aria-label="Discount code">' +
          '<button type="submit">Apply</button></form>' +
        (discountError ? '<p class="glc-discount-error" role="alert">' + esc(discountError) + '</p>' : '');
    }
    if (savings > 0 || codes.length) {
      html += '<div class="glc-row glc-row--savings"><span>' + esc(C.savingsLabel) + '</span><span class="glc-codes">' +
        codes.map(function (c) {
          return '<span class="glc-code">' + esc(c.code) + (C.showDiscount ? ' <button type="button" data-glc-rmcode="' + esc(c.code) + '" aria-label="Remove code ' + esc(c.code) + '">×</button>' : '') + '</span>';
        }).join('') +
        '</span><span>-' + money(savings) + '</span></div>';
    }
    html += '<div class="glc-row glc-row--subtotal"><span>' + esc(C.subtotalLabel) + '</span><span>' + money(cart.total_price) + '</span></div>' +
      '<button type="button" class="glc-checkout" data-glc-checkout>' + esc(C.checkoutText) + ' · ' + money(cart.total_price) + '</button>';
    footer.innerHTML = html;
  }

  function applyCodes(list) {
    return api('/cart/update.js', { discount: list.join(',') });
  }

  /* ---------- bind to the drawer markup (re-run when theme editor re-renders it) ---------- */
  function bind() {
    C = window.GLCartConfig;
    drawer = document.getElementById('glcDrawer');
    overlay = document.getElementById('glcOverlay');
    if (!drawer || !overlay || !C) return false;
    body = drawer.querySelector('[data-glc-body]');
    footer = drawer.querySelector('[data-glc-footer]');
    timerEl = drawer.querySelector('[data-glc-timer]');
    timerClock = drawer.querySelector('[data-glc-timer-clock]');
    overlay.addEventListener('click', close);
    drawer.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-glc-close]')) { close(); return; }
      if (t.closest('[data-glc-close-link]')) { close(); return; }
      if (busy) return;

      var q = t.closest('[data-glc-qty]');
      if (q) {
        var qRow = q.closest('.glc-item');
        var shown = parseInt(qRow.querySelector('.glc-qty span').textContent, 10) || 1;
        quickChange(q.getAttribute('data-glc-qty'), Math.max(0, shown + parseInt(q.getAttribute('data-step'), 10)), qRow);
        return;
      }

      var rm = t.closest('[data-glc-remove]');
      if (rm) { quickChange(rm.getAttribute('data-glc-remove'), 0, rm.closest('.glc-item')); return; }

      var add = t.closest('[data-glc-add]');
      if (add && add.getAttribute('data-glc-add')) {
        add.disabled = true;
        withBusy(api('/cart/add.js', { items: [{ id: parseInt(add.getAttribute('data-glc-add'), 10), quantity: 1 }] }));
        return;
      }

      var nav = t.closest('[data-glc-up]');
      if (nav) {
        var n = upsellProducts.length;
        upsellIndex = (upsellIndex + parseInt(nav.getAttribute('data-glc-up'), 10) + n) % n;
        var track = body.querySelector('.glc-upsell__track');
        if (track) track.style.transform = 'translateX(-' + (upsellIndex * 100) + '%)';
        return;
      }

      if (t.closest('[data-glc-dtoggle]')) {
        discountOpen = !discountOpen; renderFooter();
        if (discountOpen) { var inp = footer.querySelector('input[name="code"]'); if (inp) inp.focus(); }
        return;
      }

      var rc = t.closest('[data-glc-rmcode]');
      if (rc) {
        var keep = (cart.discount_codes || []).map(function (c) { return c.code; }).filter(function (c) { return c !== rc.getAttribute('data-glc-rmcode'); });
        discountError = '';
        withBusy(applyCodes(keep));
        return;
      }

      if (t.closest('[data-glc-checkout]')) {
        t.closest('[data-glc-checkout]').disabled = true;
        window.location.href = root + '/checkout';
      }
    });

    drawer.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-glc-dform]');
      if (!form) return;
      e.preventDefault();
      var code = form.code.value.trim();
      if (!code || busy) return;
      var existing = (cart.discount_codes || []).map(function (c) { return c.code; });
      if (existing.indexOf(code) === -1) existing.push(code);
      discountError = '';
      busy = true;
      drawer.classList.add('glc-loading');
      applyCodes(existing).then(function (c) {
        var applied = (c.discount_codes || []).find(function (d) { return d.code.toLowerCase() === code.toLowerCase(); });
        if (!applied || !applied.applicable) {
          discountError = 'The code "' + code + '" can\'t be used with this cart.';
          var keep = (c.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
          return applyCodes(keep);
        }
        discountOpen = false;
      }).catch(function () {
        discountError = 'Couldn\'t apply that code. Check it and try again.';
      }).then(function () { return refresh(); })
        .then(function () { busy = false; drawer.classList.remove('glc-loading'); });
    });

    drawer.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-glc-switch]');
      if (sel && !busy) {
        var key = sel.getAttribute('data-glc-switch');
        var line = cart.items.find(function (it) { return it.key === key; });
        if (!line) return;
        var newId = parseInt(sel.value, 10);
        withBusy(
          api('/cart/change.js', { id: key, quantity: 0 }).then(function () {
            return api('/cart/add.js', { items: [{ id: newId, quantity: line.quantity, properties: line.properties || {} }] });
          })
        );
        return;
      }
      var up = e.target.closest('[data-glc-upvar]');
      if (up) {
        var card = up.closest('.glc-upsell__card');
        var opt = up.options[up.selectedIndex];
        card.querySelector('[data-glc-add]').setAttribute('data-glc-add', up.value);
        card.querySelector('[data-glc-upprice]').textContent = money(parseInt(opt.getAttribute('data-price'), 10));
      }
    });


    return true;
  }
  window.GLCart.rebind = function () { if (bind()) refresh(); };

  document.addEventListener('keydown', function (e) {
    if (!drawer) return;
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    if (e.key === 'Tab' && drawer.classList.contains('is-open')) {
      var f = drawer.querySelectorAll('a[href], button:not([disabled]), input, select');
      if (!f.length) return;
      var firstEl = f[0], lastEl = f[f.length - 1];
      if (e.shiftKey && document.activeElement === firstEl) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); firstEl.focus(); }
    }
  });
  window.addEventListener('resize', positionTierLabels);

  // Header cart icon / any link to /cart opens the drawer
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var a = e.target.closest('a[href]');
    var trigger = e.target.closest('[data-cart-toggle], [data-open-cart], .js-open-cart');
    if (a && !a.closest('.glc-drawer')) {
      var url;
      try { url = new URL(a.href, location.href); } catch (err) { return; }
      if (url.origin === location.origin && url.pathname.replace(/\/$/, '') === root + '/cart') {
        e.preventDefault(); e.stopPropagation(); open(); return;
      }
    }
    if (trigger && !trigger.closest('.glc-drawer')) { e.preventDefault(); e.stopPropagation(); open(); }
  }, true);

  // Watch the theme's own cart requests (add to cart buttons, bundles, etc.)
  function watchUrl(url, method) {
    url = String(url || '');
    if (/\/cart\/add(\.js|\.json)?(\?|$)/.test(url)) return 'add';
    if (/\/cart\/(change|update|clear)(\.js|\.json)?(\?|$)/.test(url) && (method || 'GET').toUpperCase() === 'POST') return 'change';
    return null;
  }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url);
    var method = (init && init.method) || (input && input.method) || 'GET';
    var kind = watchUrl(url, method);
    if (kind === 'add' && drawer) addStarted();
    var p = nativeFetch(input, init);
    if (kind === 'add' && drawer) {
      p.then(function (r) {
        if (!r.ok) { addFinished(false); return; }
        lastChange = performance.now();
        r.clone().json().then(function (j) { addFinished(true, j); }, function () { addFinished(true); });
      }, function () { addFinished(false); });
    } else if (kind) {
      p.then(function (r) {
        if (!r.ok) return;
        lastChange = performance.now();
        setTimeout(function () { refresh(); }, 60);
      }).catch(function () {});
    }
    return p;
  };
  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    var kind = watchUrl(url, method);
    if (kind === 'add' && drawer) {
      addStarted();
      this.addEventListener('loadend', function () {
        var ok = this.status >= 200 && this.status < 300, j = null;
        if (ok) { try { j = JSON.parse(this.responseText); } catch (e) {} }
        addFinished(ok, j);
      });
    } else if (kind) {
      this.addEventListener('load', function () {
        if (this.status < 200 || this.status >= 300) return;
        lastChange = performance.now();
        setTimeout(function () { refresh(); }, 60);
      });
    }
    return xhrOpen.apply(this, arguments);
  };

  // Theme editor: open the drawer when its settings are selected
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#glcDrawer')) open();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#glcDrawer')) close();
  });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#glcDrawer')) window.GLCart.rebind();
  });

  // Initial load: sync gifts quietly and update counts
  if (bind()) refresh();
})();
